import { MessageCircle } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const WA_NUMBER = "27600000000"; // Replace with real WA number
const WA_MESSAGE = encodeURIComponent(
  "Hi WrenchOnWheels! I need a mobile mechanic. Can you help?"
);

export default function FloatingWhatsApp() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className={`fixed z-40 right-5 bottom-24 md:bottom-8 group transition-all duration-300 hover:scale-105 active:scale-95`}
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      {/* Button */}
      <div className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_4px_20px_rgba(37,211,102,0.4)] hover:shadow-[0_6px_28px_rgba(37,211,102,0.55)]">
        <MessageCircle size={26} strokeWidth={2} />
      </div>
      {/* Tooltip */}
      <div className={`absolute right-[calc(100%+12px)] top-1/2 -translate-y-1/2 whitespace-nowrap px-3 py-1.5 rounded-lg text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none ${isDark ? "bg-[#141419] text-white border border-[#222226]" : "bg-white text-slate-900 shadow-lg border border-slate-200"}`}>
        Chat on WhatsApp
      </div>
    </a>
  );
}
